import { createContext, useContext } from 'react';

export type EnsureCsrfToken = () => Promise<string>;

export const CsrfContext = createContext<EnsureCsrfToken>(async () => '');

export const useEnsureCsrfToken = (): EnsureCsrfToken => useContext(CsrfContext);
